/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=73cd3310&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=73cd3310&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cd3310"]])

export default __exports__